@if (isLoading | async) {
  <div
    class="loader-icon__backdrop"
    >
    <m-loader-icon />
  </div>
}
